module.exports = __webpack_public_path__ + "img/dekstop-screen.85b20031.svg";